import { render, staticRenderFns } from "./DesktopBetaWindowsInstallDialog.vue?vue&type=template&id=36b487c4&scoped=true"
import script from "./DesktopBetaWindowsInstallDialog.vue?vue&type=script&lang=ts"
export * from "./DesktopBetaWindowsInstallDialog.vue?vue&type=script&lang=ts"
import style0 from "./DesktopBetaWindowsInstallDialog.vue?vue&type=style&index=0&id=36b487c4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b487c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36b487c4')) {
      api.createRecord('36b487c4', component.options)
    } else {
      api.reload('36b487c4', component.options)
    }
    module.hot.accept("./DesktopBetaWindowsInstallDialog.vue?vue&type=template&id=36b487c4&scoped=true", function () {
      api.rerender('36b487c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/DesktopBetaWindowsInstallDialog.vue"
export default component.exports